var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoSuggestedRedactionTerms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 129,
    viewBox: "0 0 165 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_353_39231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3004 19.929C15.9204 19.929 17.2404 18.6193 17.2404 17.0119C17.2404 15.4045 15.9204 14.0947 14.3004 14.0947C12.6804 14.0947 11.3604 15.4045 11.3604 17.0119C11.3604 18.6193 12.6804 19.929 14.3004 19.929Z",
    stroke: "#B8B5DD",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4097 19.929C30.0297 19.929 31.3497 18.6193 31.3497 17.0119C31.3497 15.4045 30.0297 14.0947 28.4097 14.0947C26.7897 14.0947 25.4697 15.4045 25.4697 17.0119C25.4697 18.6193 26.7897 19.929 28.4097 19.929Z",
    stroke: "#B8B5DD",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.44 19.929C44.06 19.929 45.38 18.6193 45.38 17.0119C45.38 15.4045 44.06 14.0947 42.44 14.0947C40.82 14.0947 39.5 15.4045 39.5 17.0119C39.5 18.6193 40.82 19.929 42.44 19.929Z",
    stroke: "#B8B5DD",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.96 125.681C5.84 125.681 2.5 122.367 2.5 118.279V10.7214C2.5 6.63338 5.84 3.31934 9.96 3.31934H155.03C159.15 3.31934 162.49 6.63338 162.49 10.7214V116.602C162.49 116.602 162.78 125.671 153.7 125.671H28.74C24.19 125.671 20.5 122.01 20.5 117.495V33.7411H144.5V115.233",
    stroke: "#B8B5DD",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.22 46.9609H87.0469V111.922H131.22V46.9609Z",
    stroke: "#B8B5DD",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9525 46.9609H33.7793V111.922H77.9525V46.9609Z",
    stroke: "#4230E5",
    strokeWidth: 5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_353_39231"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 165,
    height: 127.323,
    fill: "white",
    transform: "translate(0 0.838867)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSuggestedRedactionTerms);
export default __webpack_public_path__ + "static/media/no-suggested-redaction-terms.d02409f27a186810bbde0839a5c30fc4.svg";
export { ForwardRef as ReactComponent };